// Silences common console outputs in production builds so end users do not see
// verbose debugging information. Errors and warnings remain untouched.
const noop: (...args: unknown[]) => void = () => {
  // Intentionally empty
};

const suppressedMethods: Array<'log' | 'debug' | 'info' | 'trace' | 'table'> = [
  'log',
  'debug',
  'info',
  'trace',
  'table',
];

if (process.env.NODE_ENV === 'production') {
  suppressedMethods.forEach((method) => {
    try {
      console[method] = noop;
    } catch {
      // Swallow assignment errors silently; console output is non-critical.
    }
  });
}

export {};
